var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "40px 50px" },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: [
                    "platform:sign:get:config",
                    "platform:sign:edit:base:config",
                  ],
                  expression:
                    "['platform:sign:get:config', 'platform:sign:edit:base:config']",
                },
              ],
              ref: "signForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.signForm,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "每日签到奖励：", prop: "integral" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.signForm.isIntegral,
                            callback: function ($$v) {
                              _vm.$set(_vm.signForm, "isIntegral", $$v)
                            },
                            expression: "signForm.isIntegral",
                          },
                        },
                        [_vm._v("赠送积分值")]
                      ),
                      _c("el-input-number", {
                        staticClass: "ml40",
                        attrs: { min: 0, max: 9999, step: 1, label: "积分值" },
                        model: {
                          value: _vm.signForm.integral,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.signForm,
                              "integral",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "signForm.integral",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-form-item", { attrs: { prop: "experience" } }, [
                _c(
                  "div",
                  { staticClass: "acea-row" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.signForm.isExperience,
                          callback: function ($$v) {
                            _vm.$set(_vm.signForm, "isExperience", $$v)
                          },
                          expression: "signForm.isExperience",
                        },
                      },
                      [_vm._v("赠送经验值")]
                    ),
                    _c("el-input-number", {
                      staticClass: "ml40",
                      attrs: { min: 0, max: 9999, step: 1, label: "经验值" },
                      model: {
                        value: _vm.signForm.experience,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.signForm,
                            "experience",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "signForm.experience",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "operation",
                  attrs: { label: "签到规则说明：", prop: "name" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "460px" },
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.signForm.signRuleDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.signForm, "signRuleDescription", $$v)
                      },
                      expression: "signForm.signRuleDescription",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small", type: "text" },
                      on: {
                        click: function ($event) {
                          _vm.signForm.signRuleDescription =
                            _vm.defaultDescription
                        },
                      },
                    },
                    [_vm._v("使用默认说明")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi(["platform:sign:edit:base:config"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("signForm")
                            },
                          },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkPermi([
            "platform:sign:get:config",
            "platform:sign:add:config",
          ])
            ? _c(
                "el-button",
                {
                  staticClass: "mt20",
                  attrs: { type: "primary" },
                  on: { click: _vm.addSign },
                },
                [_vm._v("新增连续签到奖励")]
              )
            : _vm._e(),
          _c("div", { staticClass: "from-tips mt14 mb20" }, [
            _vm._v(
              "连续签到奖励断签后会重新计算连续签到天数，达到连续天数后即可获得连续奖励"
            ),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.signConfigList, border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "连续天数", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: scope.row.show,
                              expression: "scope.row.show",
                            },
                          ],
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: scope.row.day,
                            callback: function ($$v) {
                              _vm.$set(
                                scope.row,
                                "day",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.day",
                          },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !scope.row.show,
                                expression: "!scope.row.show",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(scope.row.day))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "连续奖励", "min-width": "680" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "acea-row row-center-wrapper" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { disabled: !scope.row.show },
                                model: {
                                  value: scope.row.isIntegral,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isIntegral", $$v)
                                  },
                                  expression: "scope.row.isIntegral",
                                },
                              },
                              [_vm._v("赠送积分值")]
                            ),
                            _c("el-input-number", {
                              staticClass: "mr20",
                              attrs: {
                                disabled: !scope.row.show,
                                min: 0,
                                max: 9999,
                                step: 1,
                                label: "积分值",
                              },
                              model: {
                                value: scope.row.integral,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "integral",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.integral",
                              },
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticClass: "ml40 mr20",
                                attrs: { disabled: !scope.row.show },
                                model: {
                                  value: scope.row.isExperience,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isExperience", $$v)
                                  },
                                  expression: "scope.row.isExperience",
                                },
                              },
                              [_vm._v("赠送经验值")]
                            ),
                            _c("el-input-number", {
                              attrs: {
                                disabled: !scope.row.show,
                                min: 0,
                                max: 9999,
                                step: 1,
                                label: "经验值",
                              },
                              model: {
                                value: scope.row.experience,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "experience",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.experience",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkPermi(["platform:sign:edit:award:config"])
                          ? _c(
                              "a",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editSign(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm.checkPermi([
                          "platform:sign:add:config",
                          "platform:sign:edit:award:config",
                        ])
                          ? _c(
                              "a",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveSign(scope.row)
                                  },
                                },
                              },
                              [_vm._v("保存")]
                            )
                          : _vm._e(),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm.checkPermi(["platform:sign:delete:config"])
                          ? _c(
                              "a",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delSign(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }